import { en } from './en'
import { fr } from './fr'

export const createOpportunityPage = {
  en,
  fr
}